import { defineComponent } from "vue";

import { PatientStatus } from "../../../../../enums/PatientStatusEnum";

import HHPatientMain from "../HHPatientMain/HHPatientMain.vue";

export default defineComponent({
    components: {
        HHPatientMain
    },

    props: {
        selectedPatientDetails: {
            default: null
        },
        patientRiskDetails: {
            default: null
        },
        patientDetails: {
            default: null
        }
    },
    data(vm) {
        return {
            statusEnum: PatientStatus
        };
    }
});
